module.exports = __webpack_public_path__ + "img/iconSet-01.73e20b2b.png";